import React, { useMemo, useState } from "react";

const EmailComponents = React.memo(({ OrderEmailHistory, SendEmailModal, order, emails, productsToProcess }) => {
    const [refresh, setRefresh] = useState(0)

    const handleEmailSent = () => {
        setRefresh(prev => prev + 1);
      };
      
    return (
        <div className="whiteBox email-main-container p-4">
            {/* Send Email Section */}
            <div className="email-header">
                <div className="BlockTitle">E-mails</div>
                <SendEmailModal order={order} emails={emails} handleEmailSent={handleEmailSent} />
            </div>
            {/* Email Receiving Section */}
            <OrderEmailHistory orderId={order.order_id} refresh={refresh} />
        </div>
    );
}, (prevProps, nextProps) => {
    return (
        prevProps.order.order_id === nextProps.order.order_id &&
        prevProps.emails.length === nextProps.emails.length &&
        prevProps.productsToProcess.length === nextProps.productsToProcess.length
    );
});

export default EmailComponents;